// src/utils/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000,
});

// Injecter le token JWT dans chaque requête
api.interceptors.request.use(config => {
  const token = localStorage.getItem('kindeo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Rediriger vers /connexion si token expiré
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const isAuthRoute = window.location.pathname === '/connexion' 
                       || window.location.pathname === '/inscription';
      if (!isAuthRoute) {
        localStorage.removeItem('kindeo_token');
        localStorage.removeItem('kindeo_user');
        window.location.href = '/connexion';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
